import { ContentButton } from './button';
import { ContentIconLinkList } from './icon-link-list';

/**
 * Model definition for Footer Bar
 */
export interface ContentFooterBar {
  __component: 'content.footer-bar';
  id: string;
  linkList?: ContentIconLinkList;
  button?: ContentButton;
}

export function isContentFooterBar(obj: { __component?: string }): obj is ContentFooterBar {
  return obj.__component === 'content.footer-bar';
}
